import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useContext, useEffect, useState } from 'react';
import { DIRECTION_FORWARD, DIRECTION_BACKWARD } from './Trigger.constants';
import useWindowSize from '../../../../../../hooks/use-window-size';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import { createComponent } from '../../../../services/components';
import { ScrollableContentContext } from '../../ScrollableContent.context';
import { hasHorizontalScrollbar, hasReachedHorizontalEnd, hasReachedHorizontalStart } from '../../ScrollableContent.utils';
var defaultProps = {
  onClick: function onClick() {}
};
export default function Trigger(_ref) {
  var direction = _ref.direction,
    content = _ref.content,
    onClickProp = _ref.onClick;
  var _useContext = useContext(ScrollableContentContext),
    scrollContainerRef = _useContext.scrollContainerRef,
    startMovingBackward = _useContext.startMovingBackward,
    stopMovingBackward = _useContext.stopMovingBackward,
    startMovingForward = _useContext.startMovingForward,
    stopMovingForward = _useContext.stopMovingForward;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    disabled = _useState4[0],
    setDisabled = _useState4[1];
  function onScrollChange() {
    if (scrollContainerRef.current) {
      setShow(hasHorizontalScrollbar(scrollContainerRef));
      if (direction === DIRECTION_FORWARD) {
        setDisabled(hasReachedHorizontalEnd(scrollContainerRef));
      }
      if (direction === DIRECTION_BACKWARD) {
        setDisabled(hasReachedHorizontalStart(scrollContainerRef));
      }
    }
  }
  useWindowSize({
    onResize: onScrollChange
  });
  function onClick() {
    return _onClick.apply(this, arguments);
  }
  function _onClick() {
    _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (direction === DIRECTION_FORWARD) {
              startMovingForward();
            }
            if (direction === DIRECTION_BACKWARD) {
              startMovingBackward();
            }
            if (!onClickProp) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return onClickProp();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onClick.apply(this, arguments);
  }
  function onStopMoving() {
    stopMovingForward();
    stopMovingBackward();
  }
  useEffect(function () {
    if (scrollContainerRef.current) {
      setShow(hasHorizontalScrollbar(scrollContainerRef));
    }
  }, [scrollContainerRef.current]);
  useEffect(function () {
    if (disabled) {
      onStopMoving();
    }
  }, [disabled]);
  useEffect(function () {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.addEventListener('scroll', onScrollChange);
    }
    return function () {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.removeEventListener('scroll', onScrollChange);
      }
    };
  }, [scrollContainerRef.current]);
  var className = classNames({
    trigger: true,
    next: direction === DIRECTION_FORWARD,
    previous: direction === DIRECTION_BACKWARD
  });
  if (!show) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, createComponent(content, {
    disabled: disabled,
    onMouseDown: onClick,
    onMouseUp: onStopMoving,
    onMouseLeave: onStopMoving,
    onTouchStart: onClick,
    onTouchEnd: onStopMoving,
    onTouchCancel: onStopMoving,
    'aria-label': "Move ".concat(direction)
  }));
}
Trigger.defaultProps = defaultProps;